import { render, staticRenderFns } from "./blogger_credits.vue?vue&type=template&id=1be8806c&scoped=true"
import script from "./blogger_credits.vue?vue&type=script&lang=ts"
export * from "./blogger_credits.vue?vue&type=script&lang=ts"
import style0 from "./blogger_credits.vue?vue&type=style&index=0&id=1be8806c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be8806c",
  null
  
)

export default component.exports